import i18n from '@/i18n';
import {PeriodeItem} from '@/types';
import dateService from '@/services/dateService'

/** Calcul des dates de santé de votre enfant */
const dateEnfantService = {
	//renvoi l'index affichage de la periode en cours
	indexAffichageEnCours(dateNaissance: string):number {
		var diff = this.ageEnMois(dateNaissance);

		if (diff != -1) {
			//recuperation des periodes
			var periodes = i18n.t('components.santeenfant.subheader.periodes') as unknown as PeriodeItem[];
			//dans quelle periode est-on?
			for (let index = 0; index < periodes.length; index++) {
				const element = periodes[index];
				if (diff < element.moisMax) {
					return index;
				}
			}
		}

		return -1;
	},
	//renvoi l'index affichage du moisSel
	indexAffichageMoisSel(moisSel: string):number {
		//recuperation des periodes
		var periodes = i18n.t('components.santeenfant.subheader.periodes') as unknown as PeriodeItem[];
		//dans quelle periode est-on?
		for (let index = 0; index < periodes.length; index++) {
			const element = periodes[index];
			if (+moisSel == element.moisAffichage) {
				return index;
			}
		}

		return -1;
	},
	//renvoi le mois d'affichage a partir de l'index
	moisAffichage(dateNaissance: string):number {
		var index = this.indexAffichageEnCours(dateNaissance);
		//recuperation des periodes
		var periodes = i18n.t('components.santeenfant.subheader.periodes') as unknown as PeriodeItem[];
		if (index >= 0 && index < periodes.length) {
			return periodes[index].moisAffichage;
		}
		return -1;
	},
	//renvoi l'age en mois
	ageEnMois(dateNaissance: string):number {
		var dateDuJour = new Date();
		var dateNaissanceDate = new Date(+dateNaissance.substring(0,4), +dateNaissance.substring(4,6)-1, +dateNaissance.substring(6,8));
		if (dateNaissanceDate != null) {
			var diff = dateService.diffInMonths(dateNaissanceDate, dateDuJour);
			return diff;
		}
		return -1;
	}
};

export default dateEnfantService;